// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "authorized_cents": {
      "column": {
        "default": 0,
        "name": "authorized_cents",
        "null": false,
        "type": "integer"
      },
      "name": "authorized_cents",
      "selected_by_default": null,
      "translated": null
    },
    "balance_cents": {
      "column": {
        "default": 0,
        "name": "balance_cents",
        "null": false,
        "type": "integer"
      },
      "name": "balance_cents",
      "selected_by_default": null,
      "translated": null
    },
    "captured_cents": {
      "column": {
        "default": 0,
        "name": "captured_cents",
        "null": false,
        "type": "integer"
      },
      "name": "captured_cents",
      "selected_by_default": null,
      "translated": null
    },
    "credited_cents": {
      "column": {
        "default": 0,
        "name": "credited_cents",
        "null": false,
        "type": "integer"
      },
      "name": "credited_cents",
      "selected_by_default": null,
      "translated": null
    },
    "declined_cents": {
      "column": {
        "default": 0,
        "name": "declined_cents",
        "null": false,
        "type": "integer"
      },
      "name": "declined_cents",
      "selected_by_default": null,
      "translated": null
    },
    "fee_amount_cents": {
      "column": {
        "default": 0,
        "name": "fee_amount_cents",
        "null": false,
        "type": "integer"
      },
      "name": "fee_amount_cents",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "transaction_identifier": {
      "column": {
        "default": null,
        "name": "transaction_identifier",
        "null": false,
        "type": "string"
      },
      "name": "transaction_identifier",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "InvoicePaymentBambora",
  "collectionKey": "invoice_payment_bamboras",
  "collectionName": "invoice_payment_bamboras",
  "i18nKey": "invoice_payment_bambora",
  "camelizedLower": "invoicePaymentBambora",
  "name": "InvoicePaymentBambora",
  "nameDasherized": "invoice-payment-bambora",
  "pluralName": "invoice_payment_bamboras",
  "ransackable_associations": [
    {
      "className": "InvoicePayment",
      "collectionName": "invoice_payments",
      "foreignKey": "invoice_payment_bambora_id",
      "name": "invoice_payment",
      "macro": "has_one",
      "resource_name": "InvoicePayment",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "authorized_cents",
      "column": {
        "default": 0,
        "name": "authorized_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "authorized_currency",
      "column": {
        "default": "DKK",
        "name": "authorized_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "balance_cents",
      "column": {
        "default": 0,
        "name": "balance_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "balance_currency",
      "column": {
        "default": "DKK",
        "name": "balance_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "captured_cents",
      "column": {
        "default": 0,
        "name": "captured_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "captured_currency",
      "column": {
        "default": "DKK",
        "name": "captured_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "credited_cents",
      "column": {
        "default": 0,
        "name": "credited_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "credited_currency",
      "column": {
        "default": "DKK",
        "name": "credited_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "declined_cents",
      "column": {
        "default": 0,
        "name": "declined_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "declined_currency",
      "column": {
        "default": "DKK",
        "name": "declined_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "fee_amount_cents",
      "column": {
        "default": 0,
        "name": "fee_amount_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "fee_amount_currency",
      "column": {
        "default": "DKK",
        "name": "fee_amount_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "transaction_identifier",
      "column": {
        "default": null,
        "name": "transaction_identifier",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [],
  "paramKey": "invoice_payment_bambora",
  "primaryKey": "id"
}

/** Frontend model for InvoicePaymentBambora. */
export default class InvoicePaymentBambora extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {number} */
  authorizedCents() {
    return this.readAttributeUnderscore("authorized_cents")
  }

  /** @returns {boolean} */
  hasAuthorizedCents() {
    const value = this.authorizedCents()

    return this._isPresent(value)
  }

  /** @returns {number} */
  balanceCents() {
    return this.readAttributeUnderscore("balance_cents")
  }

  /** @returns {boolean} */
  hasBalanceCents() {
    const value = this.balanceCents()

    return this._isPresent(value)
  }

  /** @returns {number} */
  capturedCents() {
    return this.readAttributeUnderscore("captured_cents")
  }

  /** @returns {boolean} */
  hasCapturedCents() {
    const value = this.capturedCents()

    return this._isPresent(value)
  }

  /** @returns {number} */
  creditedCents() {
    return this.readAttributeUnderscore("credited_cents")
  }

  /** @returns {boolean} */
  hasCreditedCents() {
    const value = this.creditedCents()

    return this._isPresent(value)
  }

  /** @returns {number} */
  declinedCents() {
    return this.readAttributeUnderscore("declined_cents")
  }

  /** @returns {boolean} */
  hasDeclinedCents() {
    const value = this.declinedCents()

    return this._isPresent(value)
  }

  /** @returns {number} */
  feeAmountCents() {
    return this.readAttributeUnderscore("fee_amount_cents")
  }

  /** @returns {boolean} */
  hasFeeAmountCents() {
    const value = this.feeAmountCents()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  transactionIdentifier() {
    return this.readAttributeUnderscore("transaction_identifier")
  }

  /** @returns {boolean} */
  hasTransactionIdentifier() {
    const value = this.transactionIdentifier()

    return this._isPresent(value)
  }
}
